export enum GasSize {
  SmSize = 8,
  MdSize = 16,
  LgSize = 24,
  XlgSize = 32,
  XxlgSize = 40,
}

export enum GasSizeText {
  ExtraLarge = 'xlg',
  Large = 'lg',
  Small = 'sm'
}
